import { createStyles, makeStyles } from '@mui/styles'

const useStyles = makeStyles(() =>
  createStyles({
    box: {
      height: '100%',
    },
    body: {
      display: 'flex',
      flexDirection: 'column',
      gap: 30,
      paddingRight: 0,
    },
    footer: {
      display: 'flex',
      flexDirection: 'column',
      gap: 15,
    },
    footer__text: {
      fontSize: 14,
      fontWeight: 600,
      lineHeight: '140%',
      color: '#00000099',
    },
    footer__controls: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
    chart: {
      height: 269,
      width: '100%',
      marginTop: -14,
      paddingRight: 13,
    },
  })
)
export default useStyles
